import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { getAccessToken } from '@/utils/localStorage'


const axiosIns = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	timeout: 60000
})

axiosIns.interceptors.request.use(
	(config) => {

		const abortController = new AbortController()
		config.signal = abortController.signal
		store.dispatch('settings/setAbortController', { data: abortController })

		const accessToken = getAccessToken()
		if (accessToken != null) config.headers['Authorization'] = 'Bearer ' + accessToken

		return config
	},

	(error) => Promise.reject(error)
)

axiosIns.interceptors.response.use(
	(response) => {
		const res = response

		if (response.status != 200 || response.status != 201 || response.status != 204) {
			return res
		} else {
			return Promise.reject(new Error(res.message || 'Error'))
		}
	},

	(error) => {
		if (error.response && error.response.status === 401) {
			if (!router.history || router.history.current.name != 'Login') return router.push({ name: 'Login' })
		}

		return Promise.reject(error.response)
	}
)

export default axiosIns